
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-directory/contact",
      function () {
        return require("private-next-pages/partner-directory/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-directory/contact"])
      });
    }
  